import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Pendencia } from '../models/pendencia';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class PendenciaService {

  constructor(private http: HttpClient) { }

  consultarPendencias() {
    return this.http.get<Pendencia[]>(globals.apiUrl + '/api/Pendencia/Lista');
  }

  consultarPendenciaComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/Pendencia/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Pendencia/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  salvar(pendencia: Pendencia) {
    return this.http.post(globals.apiUrl + '/api/Pendencia/Salvar', pendencia);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/Pendencia/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorIdCupom(idCupom) {
    return this.http.get<any>(globals.apiUrl + '/api/Pendencia/ListarPorIdCupom',
      { params: new HttpParams().set('idCupom', idCupom) });
  }
}
